/* unplugin-vue-components disabled */import script from "./Study.vue?vue&type=script&setup=true&lang=js"
export * from "./Study.vue?vue&type=script&setup=true&lang=js"

import "./Study.vue?vue&type=style&index=0&id=a5d79cf6&lang=scss"

const __exports__ = script;

export default __exports__